import React, { memo } from 'react';
import styles from './RouteTabs.module.less';
import discountIcon from '../../static/discount/discount_tag.png';

function RouteTabs({ children, tabsList, activeTab, handleChangeTabs }) {
  return (
    <div className={styles.RouteTabs} id="RouteTabs">
      {tabsList.map(item => (
        <div
          className={`tabs-item${activeTab === item.key ? ' active' : ''}`}
          key={item.key}
          onClick={() => {
            handleChangeTabs(item);
          }}
        >
          {item.text}

          {item?.logPageKey === 'Sales_Rank' &&
            +new Date('2023-12-22 23:59:59') - +new Date() > 0 &&
            +new Date() - +new Date('2023-12-11 0:0:0') > 0 && (
              <img src={discountIcon} className="tab_icon" />
            )}
        </div>
      ))}
    </div>
  );
}

export default memo(RouteTabs);
